module.exports = __webpack_public_path__ + "media/images/sp/page_common/logo/logo_aqua-428698b9b73302fb589de3150425bc59.svg";